"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _ScreenReaderMessageConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-concur_android.css") : void 0);
var _ScreenReaderMessageConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-concur_default.css") : void 0);
var _ScreenReaderMessageConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-concur_gateway.css") : void 0);
var _ScreenReaderMessageConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-concur_ios.css") : void 0);
var _ScreenReaderMessageSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_fiori_3_dark.css") : void 0);
var _ScreenReaderMessageSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_fiori_3_hcb.css") : void 0);
var _ScreenReaderMessageSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_fiori_3_hcw.css") : void 0);
var _ScreenReaderMessageSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_fiori_3.css") : void 0);
var _ScreenReaderMessageSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_horizon_dark.css") : void 0);
var _ScreenReaderMessageSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_horizon_hcb.css") : void 0);
var _ScreenReaderMessageSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_horizon_hcw.css") : void 0);
var _ScreenReaderMessageSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage-sap_horizon.css") : void 0);
var _excluded = ["className", "classNameMap", "children", "delay", "isAlert", "onMessageAnnounced", "announce"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _ScreenReaderMessageConcur_android.default,
  concur_default: _ScreenReaderMessageConcur_default.default,
  concur_gateway: _ScreenReaderMessageConcur_gateway.default,
  concur_ios: _ScreenReaderMessageConcur_ios.default,
  sap_fiori_3_dark: _ScreenReaderMessageSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _ScreenReaderMessageSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _ScreenReaderMessageSap_fiori_3_hcw.default,
  sap_fiori_3: _ScreenReaderMessageSap_fiori_.default,
  sap_horizon_dark: _ScreenReaderMessageSap_horizon_dark.default,
  sap_horizon_hcb: _ScreenReaderMessageSap_horizon_hcb.default,
  sap_horizon_hcw: _ScreenReaderMessageSap_horizon_hcw.default,
  sap_horizon: _ScreenReaderMessageSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-screen-reader-message';

/**
 * The **ScreenReaderMessage** component provides a way to
 * programmatically expose dynamic content changes in a way
 * that can be announced by screen readers.
 *
 * It is important to note that, at this time,
 * screen readers do not inform users of alerts that are present on the page
 * before page load completes. Use the **ScreenReaderMessage** component when
 * a message is not tied to a page refresh or clicking a button that completes
 * a workflow (like submitting a form).
 *
 * See the [Patterns/Message Handling](./?path=/docs/patterns-message-handling--docs) page
 * for more detailed information on selecting the appropriate messaging component.
 */

var ScreenReaderMessage = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(ScreenReaderMessage, _props)) : _props;
  var className = props.className,
    classNameMap = props.classNameMap,
    children = props.children,
    delay = props.delay,
    isAlert = props.isAlert,
    onMessageAnnounced = props.onMessageAnnounced,
    announce = props.announce,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(children),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(CSS_BLOCK, className);
  var setChildrenTimer;
  var resetTimer;
  (0, _react.useEffect)(function () {
    if (announce) {
      clearTimeout(setChildrenTimer);
      clearTimeout(resetTimer);
      setMessage('');
      // set timer to render message in order for JAWS to pick up
      // the span's update on initial load
      setChildrenTimer = setTimeout(function () {
        setMessage(children);
      }, 50);

      // set timer to reset message state and call consumer callback
      resetTimer = setTimeout(function () {
        setMessage('');
        onMessageAnnounced();
      }, delay);
    }
    return function () {
      clearTimeout(setChildrenTimer);
      clearTimeout(resetTimer);
    };
  }, [announce]);
  (0, _react.useEffect)(function () {
    if (!announce) {
      setMessage(children);
    }
  }, [children]);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: ref,
    role: isAlert ? 'alert' : 'status'
  }), message);
});
ScreenReaderMessage.displayName = 'ScreenReaderMessage';
ScreenReaderMessage.propTypes = {
  /** Text to read to the consumer. */
  children: _propTypes.default.string,
  /** Controls the length of the `setTimeout` delay for clearing the message from the DOM.
  * Default delay is 1000ms if this prop is not set.
  * Use milliseconds ie. `1500`
  */
  delay: _propTypes.default.number,
  /** Set `isAlert` to **true** to interrupt the user,
   * by adding `role="alert"`, which implicitly has `aria-live="assertive"`.
   *
   * This should be avoided unless absolutely necessary.
   * Consider using a **MessageBox** or
   * **MessageView** instead.
   *
   * When `isAlert` is unset or falsy the component has `role="status"`
   * which implicitly has`aria-live="polite"` and is less aggressive.
   * */
  isAlert: _propTypes.default.bool,
  /** Custom classes to be added to the `<span>` tag.  */
  className: _propTypes.default.string,
  /** Controls whether the message (children) is rendered. This assists screen readers
   * announce a message that was not part of the DOM on page load. Use in conjunction
   * with the `onMessageAnnounced` prop.
   */
  announce: _propTypes.default.bool,
  /** Callback function when the message (children)
   * removes itself from the DOM after several seconds.
   * This assists screen readers announce a message more than
   * once when the message is identical to the last. Use in
   * conjunction with the `announce` prop.
   * */
  onMessageAnnounced: _propTypes.default.func
};
ScreenReaderMessage.defaultProps = {
  delay: 1000,
  isAlert: false
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(ScreenReaderMessage);
exports.default = _default;